import { useTranslation } from 'react-i18next';
import type { User } from '../../lib/auth.ts';
import { LanguageSwitcher } from '../LanguageSwitcher.tsx';
import { Field } from './fields.tsx';

export function AccountTab({
  user, onLogout,
}: Readonly<{ user: User | null; onLogout: () => void }>) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4">
      <Field label={t('profile.account.name')} value={user?.name ?? ''} disabled />
      <Field label={t('profile.account.email')} value={user?.email ?? ''} disabled />
      <p className="text-xs text-(--color-text-secondary)">
        {t('profile.account.managed')}
      </p>

      {/* Language picker — duplicated from the desktop sidebar so
          mobile users (no sidebar) can still switch languages. */}
      <div className="rounded-lg border border-(--color-border) bg-(--color-bg-tertiary)/40 p-4">
        <h3 className="text-sm font-semibold text-(--color-text-primary) mb-2">
          {t('profile.account.languageTitle')}
        </h3>
        <p className="text-xs text-(--color-text-secondary) mb-3">
          {t('profile.account.languageBody')}
        </p>
        <LanguageSwitcher />
      </div>

      {/* Quick sign-out so mobile users don't have to dig into
          Danger Zone for a routine action. */}
      <div className="rounded-lg border border-(--color-border) bg-(--color-bg-tertiary)/40 p-4">
        <h3 className="text-sm font-semibold text-(--color-text-primary) mb-2">
          {t('profile.account.signOutTitle')}
        </h3>
        <p className="text-xs text-(--color-text-secondary) mb-3">
          {t('profile.account.signOutBody')}
        </p>
        <button
          onClick={onLogout}
          className="px-4 py-2 rounded-lg text-sm font-medium border border-(--color-border) text-(--color-text-secondary) hover:text-red-400 hover:border-red-400/40 hover:bg-red-500/10 transition-colors"
        >
          {t('profile.account.signOut')}
        </button>
      </div>
    </div>
  );
}
